"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides UniqueId for newly created Sub Entities'
 * @param {MainEntity} mainEntity
 * @param {string} systemName
 * @returns {number}
 */
function getUniqueIdForSubEntity(mainEntity, systemName) {
    var subEntityItems = mainEntity.getProperty(systemName).value;
    var subEntityIds = subEntityItems.map(function (subEntity) {
        return subEntity.getId();
    });
    var subEntityIdMinValue = subEntityItems.length > 0 ? Math.min.apply(Math, subEntityIds) : 0;
    return subEntityIdMinValue > 0 ? -1 : subEntityIdMinValue - 1;
}
exports.getUniqueIdForSubEntity = getUniqueIdForSubEntity;
/**
 * Adds/removes selected item to/from list of selected items and puts the value in MainEntity
 * @param {any} event
 * @param {MainEntity} mainEntity - mainEntity in which the value must be put
 * @param {string} systemName - changed Item system name
 * @param {Classifier} selectedItem
 */
function onMultiSelectItemsChanged(event, mainEntity, systemName, selectedItem) {
    var selectedItems = mainEntity.getProperty(systemName).value;
    _processSelectedItems(event, selectedItems, selectedItem);
}
exports.onMultiSelectItemsChanged = onMultiSelectItemsChanged;
/**
 * Adds/removes selected item to/from list of selected items.
 * @param {any} event - Item change event.
 * @param {Array<ClassifierView>} selectedItems - The list of selected items.
 * @param {ClassifierView} selectedItem
 */
function _processSelectedItems(event, selectedItems, selectedItem) {
    var isChecked = event.currentTarget.checked;
    if (isChecked) {
        selectedItems.push(selectedItem);
    }
    else {
        for (var i = 0; i < selectedItems.length; i++) {
            if (selectedItem.getId() === selectedItems[i].getId()) {
                selectedItems.splice(i, 1);
            }
        }
    }
}
function todayUTC() {
    var today = new Date();
    return Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
}
exports.todayUTC = todayUTC;
//# sourceMappingURL=common-helper.js.map